import React, { CSSProperties, ReactElement } from 'react'
import { Image, userLoading } from 'Components/view-image'
import Link from 'next/link'
import classNames from 'classnames'
import { Wrapper } from 'lib/noop-wrapper'
import {
  preventDefault,
  stopPropagation,
} from 'Components/new/community-card/interact'
import { isNewVersion } from 'Components/hooks/use-version'

export interface IUgcUserLinkParams {
  userId?: string
  target?: string
}

export function ugcUserLink({
  userId,
  target = '_blank',
}: IUgcUserLinkParams): Wrapper {
  return (content) => {
    return userId ? (
      <Link
        href={
          isNewVersion()
            ? `/new_profile?theUserId=${userId}`
            : `/profile?theUserId=${userId}`
        }
        as={`/user/ugc_profile/${userId}`}
      >
        <a target={target}>{content}</a>
      </Link>
    ) : (
      content
    )
  }
}

export interface IProps {
  onClick?: () => void
  avatar?: string // 用户头像 url
  userId?: string // 用户id
  username?: string // 用户名
  userVerified?: boolean // 用户认证
  verifyType?: number // 用户认证类型
  size?: number
  style?: CSSProperties
  className?: string
}

const Avatar: React.FC<IProps> = ({
  onClick,
  avatar = '',
  userVerified = false,
  verifyType = 1,
  userId,
  username,
  size = 40,
  style,
  className,
}) => {
  const stopClick = stopPropagation(onClick)
  const preventClick = preventDefault(stopClick)

  return (
    <div
      className={classNames('avatar-img', className)}
      style={style}
      onClick={userId ? stopClick : preventClick}
    >
      {ugcUserLink({ userId })(
        <React.Fragment>
          <Image
            src={avatar}
            alt={`${username || ''}头像`}
            className="avatar"
            lazy={true}
            width={size * 2}
            height={size * 2}
            cusDefaultImg={userLoading}
            style={{ width: size, height: size, borderRadius: size }}
          />
          {userVerified ? (
            <i
              className={classNames('author-v', {
                'v-yellow': verifyType === 1,
                'v-blue': verifyType === 2,
              })}
            />
          ) : null}
        </React.Fragment>
      )}
      <style jsx>
        {`
          .avatar-img {
            position: relative;
            display: inline-block;
            overflow: hidden;
            vertical-align: middle;
            line-height: 1;
          }
          .avatar-img :global(img) {
            background: #e6e8f2;
            border: 1px solid #fff;
          }
          .author-v {
            position: absolute;
            right: 0;
            bottom: 0;
            display: block;
            width: 12px;
            height: 12px;
            background-repeat: no-repeat;
            background-position: center;
            background-size: cover;
          }
          .v-yellow {
            background-image: url(${require('static/v-y.svg')});
          }
          .v-blue {
            background-image: url(${require('static/v_blue_24.png')});
          }
        `}
      </style>
    </div>
  ) as ReactElement
}

export default Avatar
